import Typography from '~/components/Typography';

type Size = '6xl' | '5xl' | '4xl' | '3xl' | '2xl' | 'xl' | 'lg' | 'md' | 'sm' | 'xs';

interface Props {
  title: {
    text: string;
    fontFamily: string;
    color: string;
    size?: Size;
    className?: string;
  };
  subtitle: {
    text: string;
    fontFamily: string;
    color: string;
    size?: Size;
    className?: string;
  };
}

const PostTitles = ({ title, subtitle }: Props) => {
  return (
    <div className="cursor-pointer space-y-1">
      <Typography
        as="h2"
        size={title?.size || '2xl'}
        weight="semibold"
        className="line-clamp-2 hover:underline sm:line-clamp-3"
        fontFamily={title.fontFamily}
        fontFamilyv2={title.fontFamily}
        color={title.color}
      >
        {title.text}
      </Typography>
      {subtitle.text && (
        <Typography
          as="p"
          size={subtitle?.size || 'md'}
          weight="light"
          className="line-clamp-2 sm:line-clamp-3"
          fontFamily={subtitle.fontFamily}
          fontFamilyv2={subtitle.fontFamily}
          color={subtitle.color}
        >
          {subtitle.text}
        </Typography>
      )}
    </div>
  );
};

export default PostTitles;
